'use strict';

window.map = L.map('zmap', {
  crs: L.CRS.EPSG900913,
  attributionControl: false,
  renderer: L.svg(),
  zoomControl: false
}).setView([window.locationInfo.lat, window.locationInfo.lon], 6);

var layerOpts = {
  subdomains: ['01', '02', '03', '04'],
  maxZoom: 17,
  minZoom: 3
};

var layers = {
  terLayer: 'http://mt{mapIndex}.google.cn/vt/hl=zh-CN&gl=CN&lyrs=p&x={x}&y={y}&z={z}',
  satLayer: 'http://mt{mapIndex}.google.cn/vt/hl=zh-CN&gl=CN&lyrs=y&x={x}&y={y}&z={z}',
  busLayer: 'http://mt{mapIndex}.google.cn/vt/hl=zh-CN&gl=CN&lyrs=m&x={x}&y={y}&z={z}',
  tianditu: 'https://webrd{s}.is.autonavi.com/appmaptile?lang=zh_cn&scale=1&x={x}&y={y}&z={z}&style=8'
};

var getMapLayer = function getMapLayer(type) {
  var url = layers[type];
  if (type.indexOf('tianditu') === -1) {
    var mapIndexs = [0, 1, 2, 3];
    var index = mapIndexs[Math.floor(Math.random() * mapIndexs.length)];
    url = url.replace('{mapIndex}', index);
  }
  return new L.tileLayer(url, layerOpts);
};

var mapLayer = getMapLayer('tianditu');
mapLayer.addTo(map);
window.areaRenderer = L.svg();
areaRenderer.addTo(map);
window.waveRenderer = L.svg();
console.log(window.waveRenderer);
waveRenderer.addTo(map);

$('.mapImg span').on('click', function (e) {
  e.stopPropagation();
  if ($(this).hasClass('layer-selected')) return;
  var beforeId = $('.mapImg .layer-selected').attr('id');
  var currentLayer = $(this).attr('id');
  var beforeLayer = mapLayer;
  mapLayer = getMapLayer(currentLayer);
  mapLayer.addTo(map);
  if (currentLayer === 'tianditu') {
    $('.accredit_msg').show();
  }
  if (currentLayer === 'satLayer') {
    $('.alarm_line-text,.defense_circle_text').css('color', 'black');
  }
  if (beforeId === 'tianditu') {
    $('.accredit_msg').hide();
  }
  map.removeLayer(beforeLayer);
  changeWindColor(currentLayer);
  $(this).addClass('layer-selected').siblings().removeClass('layer-selected');
});

var changeWindColor = function changeWindColor(type) {
  if (!$('.actualWind').hasClass('on')) return;
  var color = type === 'satLayer' ? '#eee' : '#444';
  $('.wind_veltop, .wind_velbot').css('color', color);
};

map.on('zoomend', function () {
  var zoom = map._zoom;
  var $target = $('.distance-iconOne,.distance-iconTwo,.distance-iconThree,.areaBoundary,.wind_veltop,.wind_velbot,.buoyLabel');
  if (zoom < 5) $target.hide();else $target.show();
});

var hidePopup = function hidePopup() {
  $('#tyswNav>ul>li.a').click();
  var $mapLayerBtn = $('.cloudMap ul li').eq(1).find('img');
  if ($mapLayerBtn.hasClass('on')) $mapLayerBtn.click();
  if ($('.imgEx').hasClass('on')) $('.imgEx').click();
};
map.addEventListener('movestart', hidePopup);
map.addEventListener('click', hidePopup);

var initOceanTIme = function initOceanTIme() {
  var today = Date.now();
  var html = '';
  for (var i = 1; i < 8; i++) {
    var date = today + i * 24 * 60 * 60 * 1000;
    html += '<li class="typhoonSeawave_ocean" leadtime=' + i * 24 + '><div class="oceanSeawave_div"><p>' + new Date(date).Format('dd') + '\u65E5</p></div></li>';
  }
  $(".oceanPreUl").append(html);
  $('.oceanPreUl li').eq(0).children('div').addClass('ocean_active');
};
initOceanTIme();

var polyline = null,
    polylineArr = [];
$('.defenceArea').click(function (e) {
  e.stopPropagation();
  if ($(this).hasClass('on')) {
    polyline && map.removeLayer(polyline);
    polyline = null;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = polylineArr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;

        map.removeLayer(el);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    polylineArr = [];
  } else {
    var polylines = [{
      path: [[35, 120], [35, 150], [0, 150], [0, 140]],
      color: 'blue'
    }, {
      path: [[25, 135], [25, 140], [0, 140], [0, 105], [10.5, 105]],
      color: 'yellow'
    }, {
      path: [[25, 125], [25, 135], [0, 135]],
      color: 'orange'
    }, {
      path: [[25, 119], [25, 125], [15, 125], [15, 110], [22, 110]],
      color: 'red'
    }];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = polylines[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _el = _step2.value;

        polylineArr.push(L.polyline(_el.path, {
          color: _el.color,
          dashArray: [5, 10],
          weight: 2
        }).addTo(map));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
  $(this).toggleClass('on');
});


//////////////////
// WEBPACK FOOTER
// ./js/zmapInit.js
// module id = 15
// module chunks = 0